var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,11h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v2h-2V11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,5h2v2H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,3C3.9,3,3,3.9,3,5v2c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2H5z M4.2,4.8 c0-0.3,0.2-0.5,0.5-0.5h2.5c0.3,0,0.5,0.2,0.5,0.5v2.5c0,0.3-0.2,0.5-0.5,0.5H4.8c-0.3,0-0.5-0.2-0.5-0.5V4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,13h2v2H5V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,11c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2v-2c0-1.1-0.9-2-2-2H5z M4.2,12.8 c0-0.3,0.2-0.5,0.5-0.5h2.5c0.3,0,0.5,0.2,0.5,0.5v2.5c0,0.3-0.2,0.5-0.5,0.5H4.8c-0.3,0-0.5-0.2-0.5-0.5V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,5h2v2h-2V5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,3c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2H13z M12.2,4.8 c0-0.3,0.2-0.5,0.5-0.5h2.5c0.3,0,0.5,0.2,0.5,0.5v2.5c0,0.3-0.2,0.5-0.5,0.5h-2.5c-0.3,0-0.5-0.2-0.5-0.5V4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.2b9539ddea09ff13aa897757245fcaac.svg";
export { ForwardRef as ReactComponent };